module.exports = __webpack_public_path__ + "img/cobra_screenshot_1.e5128536.jpg";